export const isEntityId = (string) => /^[0-9a-f]{32}$/.test(string);
